export const getIsBodyBackdropVisible = state => state.bodyBackdrop.isBodyBackdropVisible;
